import DialogButtonModel from "./dialog-button.model";
import DialogType from "./dialog-type.enum";
import DialogModel from "./dialog.model";
import VueDialog from "../ui/dialog.plugin.vue";
import { h, render } from "vue";

export default class DialogPluginModel {
  private parentId = "vue-dialog-parent-wrapper";
  private $root: any;

  alert(errorMsg: string): Promise<boolean> {
    return this.open(
      new DialogModel({
        Type: DialogType.Error,
        Text: errorMsg,
        Title: "Внимание",
        Buttons: [okButton],
      })
    );
  }

  success(errorMsg: string): Promise<boolean> {
    return this.open(
      new DialogModel({
        Type: DialogType.Error,
        Text: errorMsg,
        Title: "Внимание",
        Buttons: [okButton],
      })
    );
  }

  info(errorMsg: string): Promise<boolean> {
    return this.open(
      new DialogModel({
        Type: DialogType.Error,
        Text: errorMsg,
        Title: "Внимание",
        Buttons: [okButton],
      })
    );
  }

  warning(errorMsg: string, title?: string): Promise<boolean> {
    return this.open(
      new DialogModel({
        Type: DialogType.Error,
        Text: errorMsg,
        Title: title ?? "Внимание",
        Buttons: [okButton],
      })
    );
  }

  custom(data: DialogModel): Promise<any> {
    return this.open(data);
  }

  confirm(
    text: string,
    title?: string,
    buttons?: Array<DialogButtonModel>
  ): Promise<boolean> {
    return this.open(
      new DialogModel({
        Type: DialogType.Error,
        Text: text,
        Title: title || "Внимание",
        Buttons: buttons || [yesButton, noButton],
      })
    );
  }

  private open(data: DialogModel): Promise<any> {
    return new Promise((resolve) => {
      this.mountIfNotMounted(resolve);
      this.$root.exposed.show(data);
    });
  }

  private mountIfNotMounted(resolve: any) {
    let self = this;

    const dialog = h(VueDialog, {
      onChange: (res: boolean) => {
        resolve(res);
        setTimeout(() => {
          self.destroyComponent();
        }, 500);
      },
    });

    const div = document.createElement("div");
    div.id = this.parentId;
    document.body.appendChild(div);
    render(dialog, div);
    this.$root = dialog.component;
  }

  private destroyComponent() {
    const div = document.getElementById(this.parentId);
    if (div) div.remove();
  }
}

export const yesButton = new DialogButtonModel({
  Title: "Подтвердить",
  Value: true,
  ButtonClass: "vue-btn-confirm",
});

export const noButton = new DialogButtonModel({
  Title: "Отклонить",
  Value: false,
  ButtonClass: "vue-btn-reject",
});

export const okButton = new DialogButtonModel({
  Title: "Ok",
  Value: true,
  ButtonClass: "vue-btn-confirm",
});
